import PropTypes from 'prop-types';
import './styles.css';

const PaddedCard = ({ children, className }) => {
  return <div className={`padded-card ${className}`}>{children}</div>;
};

PaddedCard.defaultProps = {
  className: '',
};

PaddedCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default PaddedCard;
